import type { ShopSummary } from './api'

/**
 * Mã 6 số cho việc huỷ hoá đơn đã thu tiền.
 *
 * Kiểm tra ngay trên máy bán chứ không hỏi máy chủ: quán mất mạng giữa buổi vẫn phải huỷ
 * được cái bill vừa rung nhầm, mà chờ mạng thì khách đã đứng đó rồi.
 *
 * Máy chỉ giữ chuỗi băm, không giữ mã gốc — mở kho dữ liệu của trình duyệt ra cũng không
 * đọc thẳng ra con số. Sáu chữ số thì ai quyết tâm vẫn dò hết được; đây là cái chốt cửa
 * chống bấm nhầm và chống tiện tay, không phải cái két sắt.
 */

/** Y hệt công thức của máy chủ, nếu không thì mã đặt ở đâu cũng không mở được ở kia. */
export async function hashPasscode(shopId: string, code: string): Promise<string> {
  const bytes = new TextEncoder().encode(`sigopos:void:${shopId}:${code}`)
  const digest = await crypto.subtle.digest('SHA-256', bytes)
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('')
}

/** Quán đã đặt mã chưa. Chưa đặt thì không chặn ai cả. */
export const hasVoidPasscode = (shop: ShopSummary | null): boolean =>
  Boolean(shop?.voidPasscodeHash)

export async function checkVoidPasscode(
  shop: ShopSummary | null,
  code: string,
): Promise<boolean> {
  if (!shop?.voidPasscodeHash) return true
  return (await hashPasscode(shop.id, code)) === shop.voidPasscodeHash
}
